import request from '@/utils/request'

export function getProductPage(params) {
  return request({
    url: '/api/product/page',
    method: 'get',
    params
  })
}

export function getProductOptions(params) {
  return request({
    url: '/api/product/options',
    method: 'get',
    params
  })
}

export function getProduct(id) {
  return request({
    url: `/api/product/${id}`,
    method: 'get'
  })
}

export function saveProduct(data) {
  return request({
    url: '/api/product',
    method: 'post',
    data
  })
}

export function updateProduct(id, data) {
  return request({
    url: `/api/product/${id}`,
    method: 'put',
    data
  })
}

export function deleteProduct(id) {
  return request({
    url: `/api/product/${id}`,
    method: 'delete'
  })
}
